module.exports = __webpack_public_path__ + "static/media/we-do-it_snkbp0.edc298a5.jpg";